import { ListFilters } from 'shared/_components/list/types';

export const LIST_PAGE_SIZE: ListFilters['limit'] = 99999999; // TODO: set something after implementing pagination

export const LIST_SORT_BY: ListFilters['sortBy'] = [{ created: 'desc' }];
